import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LANGUAGE } from "./constants";
import I18NextLivingMapBackend from "I18NextLivingMapBackend";

i18n
  .use(I18NextLivingMapBackend) // Load translations through http (e.g., from a server)
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    lng: DEFAULT_LANGUAGE,
    load: "currentOnly",
    interpolation: { escapeValue: false }, // React already safe from XSS
  });

export default i18n;
